export const TICKET_MODULE_NAMESPACE = 'ticket';
export const TICKET_INIT = 'TICKET_INIT';
export const TICKET_EDIT = 'TICKET_EDIT'
export const TICKET_SOCKET_EDIT= 'TICKET_SOCKET_EDIT'
export const TICKET_LOADING = 'TICKET_LOADING';
export const TICKET_RECORD_LOADING = 'TICKET_RECORD_LOADING';
export const TICKET_GET_TICKETS = 'TICKET_GET_TICKETS';
export const TICKET_GET_TICKET = 'TICKET_GET_TICKET';
export const TICKET_SET_TICKET = 'TICKET_SET_TICKET';
export const TICKET_UPDATE_TICKETS= 'TICKET_UPDATE_TICKETS';
export const TICKET_RESET_TICKETS = 'TICKET_RESET_TICKETS';
export const TICKET_RESET_FILTERS = 'TICKET_RESET_FILTERS';
export const TICKET_GET_TICKETS_SIDEBAR = 'TICKET_GET_TICKETS_SIDEBAR';
export const TICKET_SET_TICKETS_SIDEBAR = 'TICKET_SET_TICKETS_SIDEBAR';
export const TICKET_SET_TICKETS_PARAMETER = 'TICKET_SET_TICKETS_PARAMETER';
export const TICKET_SET_TICKETS_PARAMETER_SIDEBAR = 'TICKET_SET_TICKETS_PARAMETER_SIDEBAR';
export const TICKET_SET_TICKET_SIDEBAR = 'TICKET_SET_TICKET_SIDEBAR';
export const TICKET_SET_TICKETS = 'TICKET_SET_TICKETS';
export const TICKET_GET_TICKET_ACTIONS = 'TICKET_GET_TICKET_ACTIONS';
export const TICKET_SET_TICKET_ACTIONS = 'TICKET_SET_TICKET_ACTIONS';
export const TICKET_SET_APPOINTMENT_BY_FIELD = 'TICKET_SET_APPOINTMENT_BY_FIELD';
export const TICKET_RECORD = 'TICKET_RECORD';
export const TICKET_UPDATE = 'TICKET_UPDATE';
export const TICKET_RECORD_SUCCESS = 'TICKET_RECORD_SUCCESS';
export const TICKET_ASSIGN_ME = 'TICKET_ASSIGN_ME';
export const TICKET_SET_PARAMETER = 'TICKET_SET_PARAMETER';
export const TICKET_ACTION = 'TICKET_ACTION';
export const TICKET_ACTION_LOADING = 'TICKET_ACTION_LOADING';
export const TICKET_ACTION_RECEIVE_MESSAGE = 'TICKET_ACTION_RECEIVE_MESSAGE';
export const TICKET_INCREASE_UNREAD_MESSAGE= 'TICKET_INCREASE_UNREAD_MESSAGE'
export const TICKET_INIT_UNREAD_MESSAGE = 'TICKET_INIT_UNREAD_MESSAGE'
export const TICKET_ACTION_RECEIVE_NOTIFICATION = 'TICKET_ACTION_RECEIVE_NOTIFICATION';
export const TICKET_ACTION_SEND_MESSAGE = 'TICKET_ACTION_SEND_MESSAGE';
export const TICKET_ACTION_UPDATE_MESSAGE = 'TICKET_ACTION_UPDATE_MESSAGE';
export const TICKET_ACTION_EDIT_MESSAGE = 'TICKET_ACTION_EDIT_MESSAGE';
export const TICKET_ACTION_DELETE_ATTACHMENT = 'TICKET_ACTION_DELETE_ATTACHMENT';
export const TICKET_ACTION_SEND_FILE = 'TICKET_ACTION_SEND_FILE';
export const TICKET_ACTION_ATTACHMENTS = 'TICKET_ACTION_ATTACHMENTS';
export const TICKET_RECORD_CHANNEL = 'TICKET_RECORD_CHANNEL';
export const TICKET_CLEAR_ATTACHMENTS = 'TICKET_CLEAR_ATTACHMENTS';
export const TICKET_UPDATE_CURRENT_STATE = 'TICKET_UPDATE_CURRENT_STATE';
export const TICKET_SET_TICKET_STATE = 'TICKET_SET_TICKET_STATE';
export const TICKET_ADD_SINGLE_ITEM = 'TICKET_ADD_SINGLE_ITEM';
export const TICKET_GET_TICKET_NOTIFICATION = 'TICKET_GET_TICKET_NOTIFICATION';
export const TICKET_SET_TICKET_IN_LIST_REALTIME = 'TICKET_SET_TICKET_IN_LIST_REALTIME';
export const TICKET_SET_TICKET_APPOINTMENT = 'TICKET_SET_TICKET_APPOINTMENT';
export const TICKET_RECORD_ASK_APPARTMENT = 'TICKET_RECORD_ASK_APPARTMENT';
export const TICKET_RESET = 'TICKET_RESET';
export const TICKET_REQUEST_TO_JOIN = 'TICKET_REQUEST_TO_JOIN';
export const TICKET_REQUEST_TO_JOIN_CHANNEL = 'TICKET_REQUEST_TO_JOIN_CHANNEL';
export const TICKET_GET_CHARACTER_PROBLEMS = 'TICKET_GET_CHARACTER_PROBLEMS';
export const TICKET_SET_CHARACTER_PROBLEMS = 'TICKET_SET_CHARACTER_PROBLEMS';
export const TICKET_GET_EQUIPMENT = 'TICKET_GET_EQUIPMENT';
export const TICKET_SET_EQUIPMENT = 'TICKET_SET_EQUIPMENT';
export const TICKET_GET_CLOSURE_REASON = 'TICKET_GET_CLOSURE_REASON';
export const TICKET_GET_CLOSURE_REASON_LOADING = 'TICKET_GET_CLOSURE_REASON_LOADING';
export const TICKET_GET_REASONS = 'TICKET_GET_REASON';
export const TICKET_GET_REASONS_LOADING = 'TICKET_GET_REASON_LOADING';
export const TICKET_GET_TICKET_CHANNEL = 'TICKET_GET_TICKET_CHANNEL';
export const TICKET_SET_TICKET_CHANNEL = 'TICKET_SET_TICKET_CHANNEL';
export const TICKET_ADD_PARTICIPANTS = 'TICKET_ADD_PARTICIPANTS';
export const TICKET_REMOVE_PARTICIPANTS = 'TICKET_REMOVE_PARTICIPANTS';
export const TICKET_CLOSE_CURRENT_CHANNEL = 'TICKET_CLOSE_CURRENT_CHANNEL';
export const TICKET_SET_TICKET_AFTER_JOIN = 'TICKET_SET_TICKET_AFTER_JOIN';
export const TICKET_REMOVED_PARTICIPANT = 'TICKET_REMOVED_PARTICIPANT';
export const TICKET_GET_CHANNEL = 'TICKET_GET_CHANNEL';
export const TICKET_JOIN_CHANNEL = 'TICKET_JOIN_CHANNEL';
export const TICKET_QUIT_CHANNEL = 'TICKET_QUIT_CHANNEL';
export const TICKET_REMOVE_IC = 'TICKET_REMOVE_IC';
export const TICKET_CLOSE_CHANNEL = 'TICKET_CLOSE_CHANNEL';
export const TICKET_REOPEN_CHANNEL = 'TICKET_REOPEN_CHANNEL';
export const TICKET_RESET_CURRENT_CHANNEL = 'TICKET_RESET_CURRENT_CHANNEL';
export const TICKET_UPDATE_CURRENT_CHANNEL_ACTIONS = 'TICKET_UPDATE_CURRENT_CHANNEL_ACTIONS';
export const TICKET_GET_APPOINTMENTS = 'TICKET_GET_APPOINTMENTS';
export const TICKET_INTERVENTION_REPORT = 'TICKET_INTERVENTION_REPORT';
export const TICKET_GET_TICKET_INDEPENDENT_CONTRACTORS = 'TICKET_GET_TICKET_INDEPENDENT_CONTRACTORS';
export const TICKET_ACTION_DELETE_MESSAGE = 'TICKET_ACTION_DELETE_MESSAGE';
export const TICKET_SET_EXTERNAL_APARTMENT = 'TICKET_SET_EXTERNAL_APARTMENT'
export const TICKET_SET_LOADER_STATE = 'TICKET_SET_LOADER_STATE'
export const TICKET_LOADERS = Object.freeze({
    LIST : 'TICKET_LIST',
    LIST_FILTERS : 'TICKET_LIST_FILTERS',
    SIDEBAR: 'TICKET_SIDEBAR',
    CHAT_EDITOR: 'TICKET_CHAT_EDITOR',
    CHAT_CONTENT: 'TICKET_CHAT_CONTENT',
    CHAT_HEADER: 'TICKET_CHAT_HEADER'
})
export const TICKET_GET_TICKET_PRIORITY_LEVEL = 'TICKET_GET_TICKET_PRIORITY_LEVEL';
export const TICKET_SET_TICKET_PRIORITY_LEVEL = 'TICKET_SET_TICKET_PRIORITY_LEVEL';
export const TICKET_GET_TICKET_SUBSTATUS = 'TICKET_GET_TICKET_SUBSTATUS';
export const TICKET_SET_TICKET_SUBSTATUS = 'TICKET_SET_TICKET_SUBSTATUS';
export const TICKET_GET_TICKET_PROBLEM_TYPE = 'TICKET_GET_TICKET_PROBLEM_TYPE';
export const TICKET_SET_TICKET_PROBLEM_TYPE = 'TICKET_SET_TICKET_PROBLEM_TYPE';



// WEBPACK FOOTER //
// ./src/store/ticket/ticket-types.store.ts